import {
  addMinutesToHm,
  formatTimeHm,
  minutesBetweenTimes,
} from "../components/appointmentScheduleUi";

const DEFAULT_DURATION = 5;

export function parseQueueNumber(raw: string): number | null {
  const trimmed = String(raw ?? "").trim();
  if (trimmed === "") return 0;
  if (!/^\d+$/.test(trimmed)) return null;
  const n = parseInt(trimmed, 10);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export function formatAppointmentDateYmd(value: unknown): string | null {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function collectUsedSessionQueues(
  appointments: any[],
  opts: { date: string; doctorId: string; sessionName: string }
): Set<number> {
  const used = new Set<number>();
  const sessionKey = String(opts.sessionName ?? "").trim();
  const doctorKey = String(opts.doctorId ?? "").trim();
  if (!sessionKey || !doctorKey || !opts.date) return used;

  for (const apt of appointments) {
    if (!apt) continue;
    if (String(apt.sessionName ?? "").trim() !== sessionKey) continue;
    const aptDoctor = String(apt.doctorId?._id ?? apt.doctorId ?? "").trim();
    if (aptDoctor !== doctorKey) continue;
    const aptDate = formatAppointmentDateYmd(apt.date);
    if (aptDate !== opts.date) continue;
    const q = parseQueueNumber(String(apt.queue ?? ""));
    if (q !== null) used.add(q);
  }
  return used;
}

export function suggestNextQueueNumber(used: Set<number>): string {
  let max = -1;
  used.forEach((n) => {
    if (n > max) max = n;
  });
  return String(max + 1);
}

export function buildNewAppointmentFormState(detail: any) {
  const startTime = formatTimeHm(detail?.startTime);
  const endTime = formatTimeHm(detail?.endTime);
  const fromSlot = minutesBetweenTimes(startTime, endTime);
  const interval =
    Number.isFinite(fromSlot) && fromSlot > 0 ? fromSlot : DEFAULT_DURATION;
  const resolvedEnd =
    endTime || (startTime ? addMinutesToHm(startTime, interval) : "");

  return {
    title: "",
    fullName: "",
    gender: "",
    mobileNo: "",
    dob: "",
    address: "",
    doctorId: detail?.doctorId,
    date: detail?.date,
    startTime,
    endTime: resolvedEnd,
    interval: String(interval),
    purpose: "",
    activeTime: "",
    patientId: "",
    queue: "",
    sessionName: detail?.sessionName,
  };
}
